import axios from "axios";
import env from "../../config.json";

const fetchCaseTypes = async (caseId) => {
  let userTokenEncoded = await OfficeRuntime.auth.getAccessToken();
    const queryString = caseId ? `?caseId=${caseId}` : "";

  return axios.get(`${env.casenestUrl}/word/getCaseTypes${queryString}`, {
    headers: { Authorization: `Bearer ${userTokenEncoded}` },
  });
};

const fetchCaseSummary = async (caseId, environment) => {
  let userTokenEncoded = await OfficeRuntime.auth.getAccessToken();
  return axios.get(`${env.casenestUrl}/word/getCaseSummary/${caseId}/${environment}`, {
    headers: { Authorization: `Bearer ${userTokenEncoded}` },
  });
};

const fetchUserRoles = async () => {
  let userTokenEncoded = await OfficeRuntime.auth.getAccessToken();
  return axios.get(`${env.casenestUrl}/word/getUserRoles`, {
    headers: { Authorization: `Bearer ${userTokenEncoded}` },
  });
};

const fetchSnippets = async (caseTypeId, accountId) => {
  let userTokenEncoded = await OfficeRuntime.auth.getAccessToken();
  return axios.get(`${env.casenestUrl}/snippet/caseType/${caseTypeId}/${accountId}`, {
    headers: { Authorization: `Bearer ${userTokenEncoded}` },
  });
};

const addSnippet = async (newSnippet) => {
  let userTokenEncoded = await OfficeRuntime.auth.getAccessToken();
  return axios.post(`${env.casenestUrl}/snippet`, newSnippet, {
    headers: { Authorization: `Bearer ${userTokenEncoded}` },
  });
};
const updateSnippet = async (update) => {
  let userTokenEncoded = await OfficeRuntime.auth.getAccessToken();
  return axios.patch(
    `${env.casenestUrl}/snippet`,
    { id: update.id, content: update.content },
    {
      headers: { Authorization: `Bearer ${userTokenEncoded}` },
    }
  );
};

const deleteSnippet = async (snippet) => {
  let userTokenEncoded = await OfficeRuntime.auth.getAccessToken();
  return axios.delete(`${env.casenestUrl}/snippet/${snippet.id}`, {
    headers: { Authorization: `Bearer ${userTokenEncoded}` },
  });
};

const addWordTimeEvent = async ({ liveCaseDocumentId }) => {
  let userTokenEncoded = await OfficeRuntime.auth.getAccessToken();
  return axios.post(`${env.casenestUrl}/wordTimeEvent/${liveCaseDocumentId}`, null, {
    headers: { Authorization: `Bearer ${userTokenEncoded}` },
  });
};

const fetchWordTimeEvents = async ({ liveCaseDocumentId }) => {
  let userTokenEncoded = await OfficeRuntime.auth.getAccessToken();
  return axios.get(`${env.casenestUrl}/wordTimeEvent/${liveCaseDocumentId}`, {
    headers: { Authorization: `Bearer ${userTokenEncoded}` },
  });
};

const deleteWordTimeEvents = async (liveCaseDocumentId) => {
  let userTokenEncoded = await OfficeRuntime.auth.getAccessToken();
  return axios.delete(`${env.casenestUrl}/wordTimeEvent/${liveCaseDocumentId}`, {
    headers: { Authorization: `Bearer ${userTokenEncoded}` },
  });
};

const addActivity = async ({ liveCaseDocumentId, start, caseId, duration, description }) => {
  let userTokenEncoded = await OfficeRuntime.auth.getAccessToken();
  return axios.post(
    `${env.casenestUrl}/wordTimeEvent/miscActivity`,
    { liveCaseDocumentId, start, caseId, duration, description },
    {
      headers: { Authorization: `Bearer ${userTokenEncoded}` },
    }
  );
};

const caseNestService = {
  fetchCaseTypes,
  fetchCaseSummary,
  fetchUserRoles,
  fetchSnippets,
  addSnippet,
  updateSnippet,
  deleteSnippet,
  addWordTimeEvent,
  fetchWordTimeEvents,
  deleteWordTimeEvents,
  addActivity,
};

export default caseNestService;
